import React, { useEffect, useRef } from 'react';

import styles from 'molecules/ScrollableCardList/card-list-scrollable.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { FC, ReactNode } from 'react';

interface CardListScrollableProps {
  title?: string;
  children: ReactNode[];
}

const CardListScrollable: FC<CardListScrollableProps> = ({ title, children }) => {
  const listRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!listRef.current || !listRef.current.scroll) {
      return;
    }

    const scrollPosition = window.innerWidth > 900 ? 210 : 270;
    listRef.current.scroll(scrollPosition, 0);
  }, []);

  return (
    <section className={styles.container}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {isNonEmptyArray(children) && (
        <div ref={listRef} className={styles.cardList}>
          {children}
        </div>
      )}
    </section>
  );
};

export default CardListScrollable;
